import { useEffect, useRef, useState } from 'react'
import { TextField } from '@material-ui/core'
import { debounce } from 'lodash'

const SearchTextField = ({
  defaultValue,
  onChange,
}: {
  defaultValue?: string
  onChange: (val: string | undefined) => void
}) => {
  const [value, setValue] = useState(defaultValue || '')

  useEffect(() => {
    setValue(defaultValue || '')
  }, [defaultValue])

  const handler = useRef<typeof onChange>(onChange)
  handler.current = onChange

  const debounced = useRef(
    debounce((val: string) => {
      handler.current(val)
    }, 100),
  )
  useEffect(() => {
    debounced.current(value)
  }, [value, debounced])
  return (
    <TextField
      value={value}
      label="Search school name"
      variant="outlined"
      size="small"
      onChange={(e) => {
        const newValue = e.target.value
        setValue(newValue)
      }}
    />
  )
}

export default SearchTextField
